import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../Asset/logo.png';
import './Navbar.css';

const Navbar = () => {
    const [scrollTop, setScrollTop] = useState(0);
    window.onscroll = function() {scrollFunction()};
    function scrollFunction() {
        if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
        //   document.getElementById("nav-root").style.padding = "0px";
          document.getElementById("nav").style.padding = "10px 0";
          document.getElementById("nav").style.transition = "all  0.3s";
        } else {
        //   document.getElementById("nav-root").style.padding = "8px";
          document.getElementById("nav").style.padding = "24px 0";
        }
      }

    

    const onScroll = () => {
        const winScroll = document.documentElement.scrollTop;
        const height = 
            document.documentElement.scrollHeight - 
            document.documentElement.clientHeight;

            var scrolled = (winScroll / height) * 100;

            setScrollTop(scrolled);
            console.log(scrolled);
            
    };
    console.log(scrollTop);
    useEffect(()=> {
        window.addEventListener("scroll", onScroll);

        return () => window.removeEventListener("scroll", onScroll)
    }, []);


    return (
            <div  className="my-nav  fixed-top shadow-sm">
                <nav id="nav"  class="navbar navbar-root navbar-expand-lg navbar-light container">
                <Link to="/">
            <a data-aos="fade-right" class="navbar-brand" href="#">
                <img src={logo} alt=""/>
            </a>
                </Link>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul data-aos="fade-left" class="navbar-nav ml-auto">
                    <Link to="/">
                <li class="nav-item active">
                    <a class="nav-link text-white" href="#">Home <span class="sr-only">(current)</span></a>
                </li>
                    </Link>
                    <Link to="/experience">
                <li class="nav-item">
                    <a class="nav-link text-white" href="#">Experience</a>
                </li>
                    </Link>
                    <Link to="/case-study">
                <li class="nav-item">
                    <a class="nav-link text-white" href="#">Case study</a>
                </li>
                    </Link>
                <li class="nav-item">
                    <Link to="/contact">
                    <button className="btn btn-c-primary py-2 px-4">Contact</button>
                    </Link>
                </li>
                </ul>
            
            </div>
            </nav>
            <div className="scrolling" style={{width: `${scrollTop}%`}}>
                <div>
                  
                </div>
            </div>
            </div>
    );
};

export default Navbar;